import { render, staticRenderFns } from "./detailBasicInfo.vue?vue&type=template&id=938b5cf6&scoped=true&"
import script from "./detailBasicInfo.vue?vue&type=script&lang=js&"
export * from "./detailBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailBasicInfo.vue?vue&type=style&index=0&id=938b5cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938b5cf6",
  null
  
)

export default component.exports